module.exports = __webpack_public_path__ + "static/media/home-24-logo.4f73bd13.svg";